module.exports = __webpack_public_path__ + "img/cr2_2.8f375f3c.png";